import { EDITOR_TOGGLE_ASSET_SEARCH } from './constants';

export function toggleAssetSearch() {
  return {
    type: EDITOR_TOGGLE_ASSET_SEARCH,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_TOGGLE_ASSET_SEARCH:
      return {
        ...state,
        toggleAssetSearch: !state.toggleAssetSearch,
        showBuilderCanvasLoader: false,
      };

    default:
      return state;
  }
}
